import { render, staticRenderFns } from "./BackButtonMobile.vue?vue&type=template&id=ca1e6e34&"
import script from "./BackButtonMobile.vue?vue&type=script&lang=js&"
export * from "./BackButtonMobile.vue?vue&type=script&lang=js&"
import style0 from "./BackButtonMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports